export const QA_NAME_BLOCK_EDIT_DISABLED = 'blockEditDisabled'
